<template>
  <ShopifyPackages v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyPackages>
  <OpenCartPackages v-else></OpenCartPackages>
</template>

<script>
import { ShopifyPackages, OpenCartPackages } from "./partials";
export default {
  name: "packages",
  components: { ShopifyPackages, OpenCartPackages }
};
</script>
